<template>
  <section class="section history">
    <div class="overlay pad">
      <p>{{ $t('value-history50-label') }}</p>
      <h2>
        <NumberTween :value="total" :options="{ duration: 10, delay: 1 }" auto />
      </h2>
      <transition-group name="slide-long" mode="out-in" tag="div" class="info-wrap">
        <h4 v-if="!done" :key="1">
          <NumberTween
            :value="$config.year + 1"
            :filter="false"
            :start="1968"
            :options="{ duration: 10, delay: 1 }"
            auto
            @done="done = true"
          />
        </h4>
        <h4 class="info" v-else :key="0">
          {{ $t('value-history50-description') }}
        </h4>
      </transition-group>
    </div>
    <div class="graph-container">
      <AreaGraph ref="graph" class="graph" :data="data" v-if="data.length" progressive />
    </div>
  </section>
</template>

<script>
import AreaGraph from '@/components/common/graphs/AreaGraph';
import NumberTween from '@/components/common/NumberTween';
import { random } from '@/utils';

export default {
  name: 'History50',
  components: {
    AreaGraph,
    NumberTween
  },
  data() {
    return {
      data: [],
      current: 0,
      done: false
    };
  },
  mounted() {
    this.init();
  },
  computed: {
    total() {
      return this.$store.getters['activities/history'];
    }
  },
  methods: {
    init() {
      for (let i = 0; i < 50; i++) {
        const element = { name: i, color: '#38B5CD', value: random(15, 300) };
        this.data.push(element);
      }
      this.$nextTick(() => {
        this.$refs.graph.next(46, { stagger: -10 / this.data.length });
      });
    },
    setState() {
      this.currentText.left.pop();
      this.currentText.left.push(this.currentState.left);
      setTimeout(() => {
        this.currentText.right.pop();
        this.currentText.right.push(this.currentState.right);
      }, 250);
    }
  }
};
</script>

<style lang="scss" scoped>
.history {
  background-color: $col-navy-dark;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-end;
  height: 100%;
  .graph-container {
    width: 100%;
    padding-left: $padding;
    height: 60%;
  }
  .info-wrap {
    position: relative;
    h4 {
      color: $col-red-light;
      margin-top: $padding/2;
      position: absolute;
      top: 0;
      left: 0;
      width: 80%;
      @media screen and (max-width: $mq-mobile) {
        margin-top: $padding/4;
        width: 100%;
      }
    }
    h4.info {
      color: $col-white;
    }
  }
}
</style>
